// extracted by mini-css-extract-plugin
module.exports = {"sectionFooter":"BroadbandLabelSectionFooter_sectionFooter__z4KD3"};